import { render, staticRenderFns } from "./add-type.vue?vue&type=template&id=32746622&scoped=true&"
import script from "./add-type.vue?vue&type=script&lang=js&"
export * from "./add-type.vue?vue&type=script&lang=js&"
import style0 from "./add-type.vue?vue&type=style&index=0&id=32746622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32746622",
  null
  
)

export default component.exports